(function (scope) {

scope.FormsMailChimp = function () {
	var me = this;
	me.disableStyles = function () {
		$(".newsletter-extension .newsletter").css ("visibility", "hidden");
		var docWidth = $(document).width ();
		var docHeight = $(document).height ();
		$(".newsletter-extension .newsletter").find ("*[style]:visible").each (function () {
			var rect = this.getBoundingClientRect ();
			if ((rect.x >= 0 && rect.x <= docWidth) || (rect.x + rect.width >= 0 && rect.x + rect.width <= docWidth)) {
				if ((rect.y >= 0 && rect.y <= docHeight) || (rect.y + rect.height >= 0 && rect.y + rect.height <= docHeight)) {
					$(this).attr ("style", "");
				}
			}
		});
		$(".newsletter-extension .newsletter").find ("style").remove ();
		$(".newsletter-extension .newsletter").css ("visibility", "visible");
	}
	me._tries = 0;
	me.try = function () {
		if ($(".newsletter-extension .newsletter form").length && $(".newsletter-extension .newsletter form *[style]").length) {
			setTimeout (function () {
				me.disableStyles.apply (me);
			}, 1000);
		} else if (me._tries < 100) {
			// console.log ("FormsMailChimp.try tries", me._tries);
			me._tries += 1;
			setTimeout (function () {
				me.try.apply (me);
			}, 1000);
		} else {
			$(".newsletter-extension .newsletter").show ();
		}
	}
	setTimeout (function () {
		me.try.apply (me);
	}, 1000);
}
	
}) (window);
